import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { TokenInfoAndReferral } from '@core/models/iocoins';
import { AuthTokenService } from '@core/services/auth-token.service';
import { IocoinsReferralService } from '@core/services/iocoins-referral.service';

@Injectable({ providedIn: 'root' })
export class TokenInfoResolver implements Resolve<TokenInfoAndReferral> {
  constructor(
    private readonly authTokenService: AuthTokenService,
    private readonly iocoinsReferralService: IocoinsReferralService
  ) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<TokenInfoAndReferral> {
    let token: string | null = this.authTokenService.getAuthToken();
    const tokenIsExpired = this.authTokenService.isTokenExpired();
    const tokenData = this.authTokenService.getTokenData();
    const userId = tokenData?.sub;

    const refCode = route.paramMap.get('refCode')!.trim();
    const refCodeData = await firstValueFrom(this.iocoinsReferralService.refcodeData(refCode));

    if (tokenIsExpired) {
      this.authTokenService.deleteAll();
      token = null;
    }

    return { token, tokenIsExpired, userId, refCode, refCodeData };
  }
}
